module.exports = require('./lib/emitify');
